module.exports = __webpack_public_path__ + "static/media/ocean.996103a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ocean.mp4
// module id = GAET
// module chunks = 1